import { FlexBox, Icon, IconTypes, Text } from '@fable/components'
import { useStats } from '../../lib/ctx/stats'
import { css, useTheme } from '@fable/theme'
import { CompChildren } from '@fable/types'

export interface ReaderStatCardItem {
  title: string
  value: string | CompChildren
  unit: string
  icon?: IconTypes
  element?: CompChildren
  hide?: boolean
}

export const ReaderStatCard = ({
  hide,
  title,
  value,
  unit,
  icon,
  element,
}: ReaderStatCardItem) => {
  const { colors } = useTheme()
  const theme = useStats((s) => s.theme)

  const getElement = () => {
    if (element) return element
    if (icon)
      return (
        <FlexBox
          className={css`
            width: 40px;
            height: 40px;
            border-radius: 50%;
            background-color: ${colors.uiWhite};
          `}
          centerAll
        >
          <Icon
            className={css`
              width: 20px;
            `}
            type={icon}
            fill={theme.accent}
          />
        </FlexBox>
      )

    return null
  }

  if (hide) return null

  return (
    <FlexBox
      className={css`
        padding: 8px;
        width: 100%;
        background-color: ${colors.uiWhite}1A;
        border-radius: 12px;
        gap: 8px;
      `}
      flexDirection="column"
      alignItems="center"
    >
      {getElement()}
      <FlexBox flexDirection="column" alignItems="center">
        <Text
          type="label"
          sizing="L"
          color={theme.summaryText}
          align="center"
          weight="500"
        >
          {title}
        </Text>
        <Text
          className={css`
            margin-top: 2px;
            margin-bottom: -4px;
          `}
          type="header"
          tag="span"
          custom={{ fontSize: '25px', lineHeight: '24px' }}
          color={colors.uiWhite}
          align="center"
          weight="500"
        >
          {value}
        </Text>
        <Text
          className={css`
            margin-top: 2px;
          `}
          type="label"
          sizing="L"
          color={colors.uiWhite}
          align="center"
          weight="500"
        >
          {unit}
        </Text>
      </FlexBox>
    </FlexBox>
  )
}
